import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum NotifyType {
  Sms = 1,
  Email = 2,
  //Push = 3,
  Whatsapp = 4,
  Rcs = 5,
}
EnumDescriptions.setDescriptions(NotifyType, [
  i18n.t('enums.sms'),
  i18n.t('enums.email'),
  i18n.t('enums.whatsapp'),
  i18n.t('enums.rcs'),
]);
